import React, { useState } from "react";
import { formatAssignmentStatus } from "../../utils/formatAssignmentStatus";
import { formatDuration } from "../../utils/formatDuration";

export default function PreviousVisitsSection({ history = [], currentVisitNumber }) {
  const [expandedVisit, setExpandedVisit] = useState(null);

  return (
    <div className="previous-visits">
      <div className="revisit-banner">
        <span className="revisit-icon">🔄</span>
        <div className="revisit-text">
          <strong>This is visit {currentVisitNumber} of this stage</strong>
          <p>
            This stage has been worked on before. You can expand previous visits
            below to see what was submitted and why it came back. These entries
            are read-only history, and this visit's file inputs start empty for
            fresh uploads.
          </p>
        </div>
      </div>

      {[...history].reverse().map((visit) => {
        const statusInfo = formatAssignmentStatus(visit.status);
        const isExpanded = expandedVisit === visit.visitNumber;
        const totalTime = (visit.timeLogs || []).reduce(
          (sum, log) => sum + (log.durationMinutes || 0),
          0,
        );

        return (
          <div key={visit.visitNumber} className="visit-card">
            <button
              className="visit-card-header"
              onClick={() =>
                setExpandedVisit(isExpanded ? null : visit.visitNumber)
              }
            >
              <div className="visit-meta">
                <span className="visit-number">Visit {visit.visitNumber}</span>
                <span
                  className="visit-status-badge"
                  style={{
                    backgroundColor: statusInfo.bgColor,
                    color: statusInfo.textColor,
                  }}
                >
                  {statusInfo.icon} {statusInfo.label}
                </span>
                <span className="visit-date">
                  {new Date(visit.assignedAt).toLocaleDateString("en-IN", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}
                </span>
                {totalTime > 0 && (
                  <span className="visit-time">⏱ {formatDuration(totalTime)}</span>
                )}
              </div>

              {visit.reviewNote && (
                <div className="visit-note-preview">
                  <span className="note-label">
                    {visit.status === "RETURNED"
                      ? "Sent back because:"
                      : "Rework reason:"}
                  </span>
                  <span className="note-text">"{visit.reviewNote}"</span>
                  <span className="note-by">
                    — {visit.assignedBy?.firstName} {visit.assignedBy?.lastName}
                  </span>
                </div>
              )}

              <span className="visit-expand-icon">{isExpanded ? "▲" : "▼"}</span>
            </button>

            {isExpanded && (
              <div className="visit-card-body">
                <h5 className="submissions-label">
                  What was submitted on Visit {visit.visitNumber}:
                </h5>
                {(visit.taskSubmissions || []).length === 0 ? (
                  <p className="no-submissions">
                    No tasks were submitted on this visit
                  </p>
                ) : (
                  (visit.taskSubmissions || []).map((submission) => (
                    <div key={submission.id} className="submission-item">
                      <span className="submission-label">
                        {submission.taskTitle}
                      </span>
                      {submission.taskType === "text" ? (
                        <p className="submission-value">
                          {submission.textValue || "—"}
                        </p>
                      ) : (
                        <p className="submission-file">
                          📎 {submission.fileName}
                        </p>
                      )}
                    </div>
                  ))
                )}

                <div className="visit-reviewer">
                  <span>
                    Reviewed by{" "}
                    <strong>
                      {visit.assignedBy?.firstName} {visit.assignedBy?.lastName}
                    </strong>
                    {visit.completedAt && (
                      <>
                        {" "}
                        on{" "}
                        {new Date(visit.completedAt).toLocaleDateString("en-IN", {
                          day: "numeric",
                          month: "short",
                        })}
                      </>
                    )}
                  </span>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
